tinymce.Resource.add('tinymce.html-i18n.help-keynav.ca',
'<h1>Inici de la navegació amb el teclat</h1>\n' +
  '\n' +
  '<dl>\n' +
  '  <dt>Enfocar la barra de menús</dt>\n' +
  '  <dd>Windows o Linux: Alt+F9</dd>\n' +
  '  <dd>macOS: &#x2325;F9</dd>\n' +
  "  <dt>Enfocar la barra d'eines</dt>\n" +
  '  <dd>Windows o Linux: Alt+F10</dd>\n' +
  '  <dd>macOS: &#x2325;F10</dd>\n' +
  '  <dt>Enfocar el peu de pàgina</dt>\n' +
  '  <dd>Windows o Linux: Alt+F11</dd>\n' +
  '  <dd>macOS: &#x2325;F11</dd>\n' +
  '  <dt>Enfocar la notificació</dt>\n' +
  '  <dd>Windows o Linux: Alt+F12</dd>\n' +
  '  <dd>macOS: &#x2325;F12</dd>\n' +
  "  <dt>Enfocar una barra d'eines contextual</dt>\n" +
  '  <dd>Windows, Linux o macOS: Ctrl+F9</dd>\n' +
  '</dl>\n' +
  '\n' +
  "<p>La navegació començarà en el primer element de la interfície d'usuari, que es ressaltarà o subratllarà per al primer element a\n" +
  "  la ruta de l'element de peu de pàgina.</p>\n" +
  '\n' +
  "<h1>Navegació entre seccions de la interfície d'usuari</h1>\n" +
  '\n' +
  "<p>Per desplaçar-vos des d'una secció de la interfície d'usuari a la següent, premeu la tecla <strong>Tab</strong>.</p>\n" +
  '\n' +
  "<p>Per desplaçar-vos des d'una secció de la interfície d'usuari a l'anterior, premeu les tecles <strong>Maj+Tab</strong>.</p>\n" +
  '\n' +
  "<p>L'ordre en prémer la tecla <strong>Tab</strong> d'aquestes secciones de la interfície d'usuari és:</p>\n" +
  '\n' +
  '<ol>\n' +
  '  <li>Barra de menús</li>\n' +
  "  <li>Cada grup de la barra d'eines</li>\n" +
  '  <li>Barra lateral</li>\n' +
  "  <li>Ruta de l'element del peu de pàgina</li>\n" +
  '  <li>Botó de commutació de recompte de paraules al peu de pàgina</li>\n' +
  '  <li>Enllaç de marca del peu de pàgina</li>\n' +
  "  <li>Control de canvi de mida de l'editor al peu de pàgina</li>\n" +
  '</ol>\n' +
  '\n' +
  "<p>Si no hi ha una secció de la interfície d'usuari, s'ometrà.</p>\n" +
  '\n' +
  '<p>Si el peu de pàgina té el focus de navegació del teclat i no hi ha cap barra lateral visible, en prémer <strong>Maj+Tab</strong>\n' +
  "  el focus es mou al primer grup de la barra d'eines, no l'últim.</p>\n" +
  '\n' +
  "<h1>Navegació dins de les seccions de la interfície d'usuari</h1>\n" +
  '\n' +
  "<p>Per desplaçar-vos des d'un element de la interfície d'usuari al següent, premeu la tecla de <strong>Fletxa</strong> adequada.</p>\n" +
  '\n' +
  '<p>Les tecles de fletxa <strong>Esquerra</strong> i <strong>Dreta</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  '  <li>us permeten desplaçar-vos entre menús de la barra de menús.</li>\n' +
  '  <li>obren un submenú en un menú.</li>\n' +
  "  <li>us permeten desplaçar-vos entre botons d'un grup de la barra d'eines.</li>\n" +
  "  <li>us permeten desplaçar-vos entre elements de la ruta d'elements del peu de pàgina.</li>\n" +
  '</ul>\n' +
  '\n' +
  '<p>Les tecles de fletxa <strong>Avall</strong> i <strong>Amunt</strong></p>\n' +
  '\n' +
  '<ul>\n' +
  "  <li>us permeten desplaçar-vos entre elements de menú d'un menú.</li>\n" +
  "  <li>us permeten desplaçar-vos entre elements d'un menú emergent de la barra d'eines.</li>\n" +
  '</ul>\n' +
  '\n' +
  "<p>Les tecles de <strong>Fletxa</strong> us permeten desplaçar-vos dins de la secció de la interfície d'usuari que té el focus.</p>\n" +
  '\n' +
  '<p>Per tancar un menú, un submenú o un menú emergent oberts, premeu la tecla <strong>Esc</strong>.</p>\n' +
  '\n' +
  "<p>Si el focus actual es troba a la ‘part superior’ d'una secció específica de la interfície d'usuari, en prémer la tecla <strong>Esc</strong> també es tanca\n" +
  '  completament la navegació amb el teclat.</p>\n' +
  '\n' +
  "<h1>Execució d'un element de menú o d'un botó de la barra d'eines</h1>\n" +
  '\n' +
  "<p>Quan l'element del menú o el botó de la barra d'eines que desitgeu estigui ressaltat, premeu <strong>Retorn</strong>, <strong>Intro</strong>\n" +
  "  o la <strong>barra d'espai</strong> per executar l'element.</p>\n" +
  '\n' +
  '<h1>Navegació per quadres de diàleg sense pestanyes</h1>\n' +
  '\n' +
  "<p>En els quadres de diàleg sense pestanyes, el primer component interactiu pren el focus quan s'obre el quadre diàleg.</p>\n" +
  '\n' +
  '<p>Premeu la tecla <strong>Tab</strong> o les tecles <strong>Maj+Tab</strong> per desplaçar-vos entre components interactius del quadre de diàleg.</p>\n' +
  '\n' +
  '<h1>Navegació per quadres de diàleg amb pestanyes</h1>\n' +
  '\n' +
  "<p>En els quadres de diàleg amb pestanyes, el primer botó del menú de la pestanya pren el focus quan s'obre el quadre diàleg.</p>\n" +
  '\n' +
  "<p>Per desplaçar-vos entre components interactius d'aquest quadre de diàleg, premeu la tecla <strong>Tab</strong> o\n" +
  '  les tecles <strong>Maj+Tab</strong>.</p>\n' +
  '\n' +
  "<p>Canvieu a la pestanya d'un altre quadre de diàleg, tot enfocant el menú de la pestanya, i després premeu la tecla <strong>Fletxa</strong> adequada\n" +
  '  per canviar entre les pestanyes disponibles.</p>\n');